module.exports = __webpack_public_path__ + "media/images/niq-sort-desc-b32a1cd6ed17c3c0070cc5bfaecc6ba6.svg";